// CN
export const locale = {
  MESSAGE: {
    OUTOFPOLICY: "违背政策",
    INPOLICY: "符合政策",
    CONFIRMBUTTONTEXT: "确定",
    CONFIRMBUTTONTEXT1: "已知悉",
    CONFIRMCANCELTEXT: "取消",
    PLEASEINPUT: "请输入",
    PLEASESELECT: "请选择",
    SAVE: "保存",
    HARPID: "上传成功！",
    HARPIDFAIL: "上传失败，请检查是否为csv文件并重新上传",
    CONFIRMBTN: "确认",
    RESETBTN: "重置",
    DOWNLOADSTART: "开始下载...",
  },
  ERRORMESSAGE: {
    500: "网络不稳定，请稍后再次尝试！",
    400: "信息有误，请检查后再次尝试！",
    40001: "个人信息缺失，请更新个人信息后再次尝试预定酒店！",
    403: "您的操作暂时不支持！",
    404: "您访问的资源不存在！",
    10001: "网络不稳定，请稍后再次尝试！",
    10002: "网络不稳定，请稍后再次尝试！",
    10003: "网络不稳定，请稍后再次尝试！",
    10004: "您访问的资源不存在！",
    10005: "您访问的资源不存在！",
    10006: "您的操作暂时不支持！",
    10007: "您访问的资源不存在！",
    10008: "网络不稳定，请稍后再次尝试！",
    10009: "连接超时，请稍后再试！",
    10099: "没有符合条件的出差单！",
    10101: "没有符合搜索条件的酒店！",
    10201: "暂无符合条件的房型和价格！",
    10301: "您访问的酒店资源不存在！",
    10401: "该酒店房源已售罄，请更换其他酒店！",
    10501: "更新订单失败，请稍后尝试更新订单！",
    10601: "没有符合搜索条件的酒店订单！",
    10701: "您访问的订单不存在！",
    10702: "暂无权限访问该订单！",
    10703: "订单查询失败，请稍后再试",
    10801: "该房型库存不足，请重新选择！",
    10802: "网络不稳定，请稍后再次尝试！",
    10803: "该价格类型暂不支持预订，请重新选择！",
    10804: "请稍后尝试预订！",
    10805: "该房间价格发生变化，暂时无法预订，请稍后尝试或联系客户服务小组！",
    10806: "该房型暂时无法下单，请稍后再次尝试或联系客户服务小组！",
    10807: "预定失败！",
    10810: "公司账户余额不足，请您充值后再次尝试预订！",
    10901: "该房型库存不足，请重新选择！",
    10902:
      "该房间价格发生变化，当前价格为：{oldprice}，变更后价格为：{newprice}！",
    10903: "",
    11101: "公司账户余额不足，请您充值后再次尝试预订！",
    11201: "您的订单暂时无法取消，如需帮助请联系客户服务小组！",
    11301: "订单“{OrderNo}”已经写入大订单“{ItineraryOrder}”",
    11302: "请选择要迁入的订单!",
    11303: "必须选择同一个企业的同一个人创建的订单！",
    11304: "迁入成功！",
    11305: "迁入失败！请稍后再次尝试！",
    11306: "当前企业未开启大订单！",
    13001: "订单数量超出限制，下载失败！",
    90000: "支付发生错误！",
    90001: "支付发生错误,请提供正确的支付信息继续支付！",
    90002: "当前订单不能支付或不需要支付！",
    91001: "验证码输入错误，请重新输入！",
    91002: "验证码已失效！",
    NOTFOUND: "请稍后再次尝试！",
    BOOKINGFAILED: "订单预订失败，",
    ORDER500: "订单预定失败，请稍后尝试预定或联系服务小组！",
    ORDER501: "疑似重单请10分钟后再次尝试。",
  },
  BREADCRUMB: {
    BOOKING1: "预订确认页",
    GUARANTEE: "预订担保页",
    BOOKING2: "订单详情页",
    ORDERMANAGE: "订单管理",
    ORDERLIST: "Order List",
    ORDERDETAIL: "Order Detail",
    MYORDER: "我的订单",
  },
  DATEPICKER: {
    FIRSTLABLE: "入住",
    LASTLABLE: "离店",
    NIGHT: " 晚",
    CHECKIN: "入住",
    CHECKOUT: "离店",
    MCHECKIN: "入",
    MCHECKOUT: "离",
  },
  SEARCH: {
    DESTINATION: "目的城市",
    GUESTS: "客人",
    KEYWORDS: "关键字（酒店名称或酒店地址）",
    ADDRESSSEARCH: "地址查询（确切地址或地址标签）",
    ADDRESSNOTFOUND: "抱歉，无法查询到定位",
    NOTMATCH:"抱歉，定位和查询城市不符，请更新城市后再试。",
    APPROVED: "行程单",
    CONFIRMDES: "请选择目的地，再进行酒店搜索！",
    CONFIRMCHECK: "请选择入住日期和离店日期，再进行酒店搜索！",
    CONFIRMRANGEIN:
      "审批单只允许选择“{inDate}”与“{outDate}”之间的时间入住，请重新选择入住日期！",
    CONFIRMRANGEOUT:
      "审批单只允许选择“{inDate}”与“{outDate}”之间的时间离店，请重新选择离店日期！",
    INVALID_CHECKIN_OR_CHECKOUT_DATE: "所选入住或离店日期不符合审批单要求，请检查并重新选择日期！",
    INVALID_CHECKIN_OR_CHECKOUT_DATE: "所选入住或离店日期不符合审批单要求，请检查并重新选择日期！",
    CHECKINOUTDATE:
      "根据酒店预订规则最长可连续预订{maxDay}天酒店，您预订的酒店已超出连续预订酒店上限，请您重新选择入住时间和离店时间。",
    CONFIRMDEST: "当前选择的目的地与行程单目的地不一致",
    CONFIRMTRIP: "未选择行程单或此行程单已失效",
    CHECKINOUTDATE2: "不能选择相同的入住时间和离店时间",
    CURRENCYTITLE: "币种切换",
    DOMESTICAPPROVED: "请您输入行程单国内城市进行酒店搜索预定！",
    ABROADAPPROVED: "请您输入行程单国际城市进行酒店搜索预定！",
  },
  HEADER: {
    NAV1: "国内机票",
    NAV2: "国际机票",
    NAV3: "国内酒店",
    NAV4: "火车票",
    NAV5: "租车",
    NAV6: "签证",
    BARITEM1: "欢迎 {msg}",
    OBTNAV1: "防疫工具集",
    OBTNAV2: "处理中 ({number})",
    OBTNAV3: "订单管理",
    OBTNAV4: "专享客服",
    OBTNAV5: "退出",
    FL04: "国内酒店",
    FL10: "国际酒店",
    INTLPHONE: "国际服务组电话：{intlPhone}",
    CONTACTNUM: "客服热线：{CONNUM}",
    CONTACTMAIL: "联系邮箱：{CONMAIL}",
  },
  FOOTER: {
    MES1: "版权所有&copy;2022 CWT，保留所有权利{copyLink}技术协助",
    MES2: "我们致力于保护您的个人数据和隐私。阅读 CWT 的 {privacyLink} ，了解 CWT 收集的信息和收集原因，以及 CWT如",
    MES3: "何使用和存储这些信息。另请阅读我们的 {cookieLink} 以选择您的 cookie 首选项。有关更多信息，请参阅 {termsLink} 。",
    PRIVACY_LINK: "全球隐私政策和公告",
    COOKIE_LINK: "cookie 政策", 
    TERMS_LINK: "使用条款"
  },
  HOME: {
    TITLE: "酒店查询",
    BUTTONSEARCH: "搜索",
    ONLYSEARCH:"仅查询",
    BUTTONMAP: "去往地图",
    NOTES: "公司公告：",
    // NOTES1:
    //   "针对希尔顿新会员，CWT 送您希尔顿2500会员奖励积分，截止至2021年3月31号。详情见附件。附件中链接注册得积分。",
    // NOTES2:
    //   "信用卡担保有可能会被刷取预授权；使用外币卡被刷预授权将会产生手续费及汇率差。担保失败，可能是因为有些酒店资源不支持双币信用卡以及境外发行的信用卡，请使用其他信用卡。",
    // NOTES3:
    //   "丽笙酒店集团为差旅客人推出专享价，全球1100逾家酒店限时85折，享双人早餐、免费Wi-Fi, 当日6点前免费取消礼遇，同时可赚取丽享会积分。 入住日期即日起至2021年3月底。城家公寓在CWT平台全面上线，30天以上舒心住，享受官网95折价格。适合个人租房、外派、长期项目等。 城市覆盖北京、上海、广州、深圳、杭州。搜索“城家”了解详情。",
    NOTRIPSTIPS: "未查询到出差审批单",
    TRIPSERROR: "出差单信息请求失败",
    TRIPSSELECTTIPS: "未找到有效的出差申请单，预订酒店订单请先申请出差审批单！",
    RESPONSEDATA: {
      notice: "zh-CN",
    },
    JUDGECTCITYTITLE: "此地区已被屏蔽预订！",
  },
  RESULT: {
    PRICETYPECHANGE: "约为",
    CURRENCY: "货币转换",
    USD: "USD",
    EUR: "EUR",
    CNY: "CNY",
    //temp data will be deleted
    RESPONSEDATA: {
      name: "zh-CN",
      address: "zh-CN",
      locationNameLists: "zh-CN",
    },
    RESULT: "列表",
    MAP: "地图",
    OUTOFPOLICYTIPEMPTY: "价格/星级违背政策",
    OUTOFPOLICYTIP1: "您的价格预订上限为：{price}",
    OUTOFPOLICYTIP2: "您的星级预订上限为：{star}星",
    OUTOFPOLICYTIP3: "协议价格类型不符合公司要求",
    OUTOFPOLICYTIPAdd: "{outOfPolicy}，无法在线预订， 如需要请联系服务小组。",
    DESTINATION: "目的城市",
    GUESTS: "客户",
    KEYWORDS: "关键字（酒店名称或酒店地址）",
    DISTRICT: "行政区",
    AIRORTRAIWAY: "机场/火车站",
    CUSTOM: "公司地标",
    TOTAL: "共：",
    HOTELSFOUND: "家酒店",
    CLEAR: "清空",
    CURRENTLOCATION: "当前位置",
    SEARCH: "搜索",
    PRICE: "价格",
    PRICERANGE:"价格范围",
    STARRATING: "星级",
    DISTANCE: "距离",
    SHOWONMAP: "地图显示",
    TEL: "电话:",
    ADDRESS: "地址:",
    CORPORATEPAYMENT: "公付酒店",
    CONTRACTEDHOTEL: "公司协议",
    CHAIMWIDE:"公司协议-酒店集团",
    CWTHOTEL: "CWT协议",
    ABOVE: "起",
    CHECKAVAILABILITY: "查看详情",
    SHOWMORE: "显示更多",
    NOMORE: " 没有更多可选酒店",
    NOMOREWARNING: "很抱歉，没有找到符合您搜索条件的酒店！",
    SEARCHHOTEL: "搜索页",
    LISTSEARCHHOTEL: "酒店搜索结果页",
    LOCATION: "位置",
    PAYMENT: "支付类型",
    ESTIMATEDPRICE: "参考价格",
    MOBILELOCATION: "筛选",
    MOBILESORT: "默认排序",
    MOBILESORTPRICEHIGH: "高价优先",
    MOBILESORTPRICELOW: "低价优先",
    MOBILESORTSTARHIGH: "星级降序",
    MOBILESORTSTARLOW: "星级升序",
    MOBILESELECTAIR: "请选择机场/火车站！",
    MOBILESELECTCUSTOMER: "请选择自定义坐标！",
    PRICERANGE1: "不限",
    PRICERANGE2: "0-300",
    PRICERANGE3: "300-500",
    PRICERANGE4: "500-1000",
    PRICERANGE5: "1000以上",
    PRICERANGE6: "自定义",
    PRICERANGE7: "{priceRange}以上",
    HOTHOTEL:"热门酒店",
    MOBILESELECTHOTHOTEL: "请选择热门酒店！",
    STARSELECT:"星/钻",
    STAR1:"1星/钻",
    STAR2:"2星/钻",
    STAR3:"3星/钻",
    STAR4:"4星/钻",
    STAR5:"5星/钻",
    EMISSION: "绿色环保",
    Separator: "| ",
    EMISSIONTIP: "环保碳排放量采用第三方计算方法，按房间计算，综合考虑了酒店位置、连锁品牌和星级评定。",
  },
  DETAIL: {
    TAXIN: "含税",
    TAX: "税费：",
    OTHERS: "其他：",
    TOTALTAXES: "总税费",
    TOTALFEES: "费用合计",
    AVGNIGHTLYRATE: "每晚税前均价",
    RESPONSEDATA: {
      bedtype: "zh-CN",
      facility: "zh-CN",
    },
    HOME: "搜索页",
    HOTELRESULT: "酒店搜索结果",
    DETAILPAGE: "酒店详情页",
    BTN1: "选择房间",
    BTN2: "选择",
    BTNCWTBUR: "申请",
    MSG1: "接机服务 | 24小时大堂经理 | 会议厅",
    MSG2: "显示所有设施",
    ABOVE: "起",
    ROOMTYPE: "房型",
    DESCRIPTION: "描述",
    FACILITIES: "设施",
    POLICIES: "政策",
    SLEEPS: "每间人数",
    BEDTYPE: "床型",
    BREAKFAST: "早餐",
    HASBREAKFAST: "含早餐",
    FACILITES: "设施",
    POLICY: "政策",
    RATE: "价格（税后）",
    PAYMENTTYPE: "支付方式",
    TITLE1: "上海明天广场JW万豪酒店",
    TITLE2: "设施",
    TITLE3: "酒店政策",
    TITLE4: "碳排放估算",
    CO2:"碳排量",
    CARBON_EMISSIONS: {
      NIGHTLY: "单晚住宿碳足迹：{carbonFootprint}千克二氧化碳当量。",
      TOTAL: "全程入住总碳足迹：{totalCarbonFootprint}千克二氧化碳当量。",
      DESCRIPTION: "排放量计算基于第三方方法，综合考量酒店地理位置、连锁品牌及星级评定（换算为二氧化碳当量呈现）。"
    },
    CONTENTTITLE: "不可取消/随时取消/限时取消",
    POLICYTITLE: "取消政策说明：",
    GUARANTEERULES:
      "1.【2021-12-02 00:00】前可免费取消。<br>2.限时取消时，扣款比例：全款。<br>3.取消指定金额：300CNY。<br>4.超时取消，扣除1间夜金额。",
    CONTENTTITLE2: "全部担保/首晚担保",
    NOTESTITLE: "担保描述：",
    NOTESTCON:
      "需要您提供信用卡担保。在入住之前一天可以免费取消；在入住当天取消；将收取全额担保金作为违约费用。",
    CONDITIONS: "注意事项：",
    // CONDITIONSCONTENT:
    //   "1. 不支持外宾。<br>2.最早办理入住时间：2021-12-02 14:00，最晚离店时间：2021-12-03 12:00。",
    CHECKINTIME: "最早办理入住时间：",
    CHECKOUTTIME: "最晚离店时间：",
    FOREIGNGUESTS1: "酒店仅支持中国客人入住。",
    FOREIGNGUESTS2: "酒店支持中国及外国客人入住。",
    PAYMENTTYPE1: "前台现付",
    PAYMENTTYPE2: "在线付",
    PAYMENTTYPE3: "公付",
    INSTANT: "即时预订",
    DELAY: "延时确认",
    NEGOTIATEDPRICE: "协议价格",
    GUARANTEE: "担保",
    DEPOSIT: "预付押金",
    PREPAYMENT: "预付款",
    DEPOSIT: "预付押金",
    PREPAYMENT: "预付款",
    DIALOGIMAGETITLE: "酒店图片",
    PROPERTYINFO: "基本信息",
    VIEW: "查看客房信息",

    linshi1: "大床",
    linshi2: "无早餐",
    linshi4: "¥300",
    linshi5: "免费WIFI",
    linshi6: "无WIFI",

    HOTELDEATIL:
      "描述：上海明天广场JW万豪酒店坐落于浦西区中心地带，靠近上海中央商务区，信步可至上海博物馆、上海美术馆……",
    HOTELLISTROOM: "大床房",
    HOTELLISTWINDOW: "有窗",
    HOTELDETAILFOOTER1:
      "上海明天广场JW万豪酒店坐落于浦西区中心地带，靠近上海中央商务区，信步可至上海博物馆、上海美术馆、上海大剧院、南京路购物场所以及外滩。",
    HOTELDETAILFOOTER2:
      "酒店拥有三百多间客房，位于41层至59层，每个房间都可从不同角度享受城市美景。同时享受酒店的豪华陈设和商务便利设施。",
    HOTELDETAILFOOTER3:
      "入住期间，您可到酒店38楼至40楼酒店餐厅品尝地道的中西式菜肴和时令特色菜，来一次美食之旅。也可在位于酒店60楼的行政图书馆，安静的阅读享受休闲的时光。",
    HOTELDETAILFOOTER4:
      "此外，宾客可在酒店的24小时健身俱乐部和室内/室外泳池放松享受。酒店还提供面积达1,630平方米的多功能空间，富丽堂皇，拥有壮丽的景观且自然采光，适合筹办私密婚礼和气氛活跃的会议。",
    HOTELFAC1: "Wi-Fi",
    HOTELFAC2: "浴室",
    HOTELFAC3: "付费停车场",
    HOTELFAC4: "机场接机",
    HOTELFAC5: "免费寄存行李",
    HOTELFAC6: "叫车服务",
    HOTELFAC7: "酒水服务",
    HOTELFAC8: "24h前台",
    CWTPRICE: "CWT协议价格",
    CLIENTPRICE: "公司协议价格",
    NA: "暂无数据",
    PRICECHANGED: " 对不起，该房间价格变动",
    ORGPRICE: "原价格：",
    NEWPRICE: "新价格：",
    EXCEEDEDPRICE: "您的价格预订上限为:",
    EXCEEDEDPSTAR: "您的星级预订上限为:",
    SYMBOL1: "星",
    SYMBOL2: "",
    SERVER1: "前台服务",
    SERVER2: "餐饮服务",
    SERVER3: "通用设施",
    SERVER4: "休闲娱乐",
    SERVER5: "其它",
    NOMORETITLE: "暂无符合条件的房型和价格！",
    CANCELLATIONPOLICY0: "不可取消",
    CANCELLATIONPOLICY1: "随时取消",
    CANCELLATIONPOLICY2: "限时取消",
    MOREINFO: "查看更多",
    SHOWONMAP: "地图•周边",
    SEPARATOR: "",
    GUEST: "可住{bedCount}人",
    ChainwidePrice: "-酒店集团协议价",
    LoyaltyPoints: "可积分",
    NoLoyaltyPoints: "不可积分",
    DECORATEDAT:"装修: {decoratedAt}",
    OPENEDAT:"开业时间: {openedAt}",
    SearchNearbyHotels:"查找附近酒店",
    BestPrice:"最优价",
    CannotBeCanceled:"您选择的是不可取消预定，请确认是否继续预定。"
  },
  BOOKING: {
    BOOKING: "预订详情页",
    MESSAGEPROMEPT: "以下是您预订的酒店等信息，请您认真核对:",
    HOTELTITEL: "上海明天广场JW万豪酒店",
    HOTELADDRESS: "上海市明天广场29号",
    ROOMTYPE: "房型:",
    KINGBEDGUESTROOM: "豪华大床房",
    DESCRIPTION: "房型描述:",
    ROOMDESCRIPTION: "该房型位于酒店{floor}层",
    ROOMDESCRIPTIONAREA: "房间有{area}平方米",
    BREAKFAST: "早餐:",
    RATEPLANDES: "预订类型:",
    BOOKINGCONDITIONS: "预订须知：",
    INSTANTCON: "即时预订",
    FOREIGNTRAVEL: "不支持外宾",
    FOREIGNTRAVELTRUE: "支持外宾",
    CHECKININFO: "入住信息",

    CHECKININFOMSG:
      "Please ensure booked information is as per your valid travel documents",
    TITLE: "入住人信息",
    OTHERTITLE: "其他入住人信息",
    OTHERTITLEPROMPT: "请报主入住人姓名或提供酒店确认号办理入住。",
    OTHERTITLEREPORT: "请勿填写两条同样的入住人信息",
    COLNAME: "姓名",
    COLTELEPHONE: "电话",
    EMAIL: "邮箱",
    EMPLOYEEID: "员工号",
    COSTCENTER: "成本中心",
    CHOOSENTYPE: "请选择支付方式",
    COMPANYPAY: "公付支付",
    PAYATHOTEL: "前台到付",
    EMPLOYERONE: "张先生",
    EMPLOYERTWO: "李先生",
    EMPLOYERTHREE: "王先生",
    SPECIAL: "自定义",
    SPECIALINFO: "我们会将您的需求转达给酒店，但无法确保一定能够满足",
    SPECIALALERT:
      "如果此订单未进行过线上担保，且您的到店时间晚于酒店要求的最晚到店时间，请联系酒店进行担保。",
    SPECIALALERT1:"温馨提示：您的房费由我方垫付，酒店可能会在入住时收取房费或杂费押金，您的押金将在退房当天退还。如入住期间产生其他杂费，由您自行承担",
    SPECIALALERT2:"晚于18:00入住时订单需要担保，否则可能被酒店取消。请选择准确的入住时间！",
    SPECIALALERT3:"如您晚于24点到店，请联系酒店确保房间可以被保留，以避免订单被酒店视作No-Show取消或收取罚金。",
    SPECIALALERT4:"国际和港澳台预订请提供国际信用卡担保，否则可能被酒店取消预订。",
    AVGPRICE: "Avg. 价格",
    TOTALPRICE: "应付房费",
    PRICELINK: "点击查看价格明细",
    POLICIES1: "不可取消",
    POLICIES2: "随时取消",
    POLICIES3: "限时取消",
    POLICIES4: "不可改期",
    ALLGUARANTEE1: "全部担保",
    ALLGUARANTEE2: "首晚担保",
    ALLGUARANTEE3: "无需担保",
    ALLGUARANTEE5: "预付定金",
    ALLGUARANTEEFEE: "担保描述：首夜担保或全部天数担保，实际担保费用需按照酒店的取消政策",
    ALLGUARANTEEFEE2: "担保描述：首晚或全部预订天数房费预付定金，实际预付费用根据酒店的押金担保政策随时可能被收取。",
    GUARANTEE: "担保描述:",
    NOTES: "政策说明:",
    CHECKNOTES: "我已阅读、了解并同意上述条款。我同意承担上述担保费用。",
    SUBMIT: "提交订单",
    POLICY1: "免费取消：需要【{0}】之前取消。",
    POLICY2: "取消费用：如果没有在上述时间进行取消操作或者没有办理入住，会产生取消费用（首夜费用或全部天数费用），实际取消费用应按照酒店的取消政策收取。",
    GUARANTEEDES_PART1: "您需要按照酒店要求，提供信用卡进行担保。您的信用卡信息将按照CWT数据隐私政策[",
    GUARANTEEDES_LINK: "https://www.mycwt.com/legal/global-privacy-policy/",
    GUARANTEEDES_PART2: "]进行处理。为完成房间预定，您的个人信息（包括信用卡信息）需要分享给酒店及其它第三方供应商。如果酒店位于中国境外，您的个人信息（包括信用卡信息）需要进行跨境传输。如果您不接受上述条款，我们将无法完成预定。如果您没有限时取消或者您没有办理入住，酒店将从信用卡扣除相应的担保费用。",
    PAYMENTTYPE: "支付方式",
    LATESTARRIVALT: "最晚到店时间",
    DYNAMICALLY1: "用户自定义1",
    DYNAMICALLY2: "用户自定义2",
    SPECIALREQ: "特殊需求(选填)",
    SPECIALROOM: "房型特殊需求(选填)",
    SPECIALBED: "床型特殊需求(选填)",
    OPTION: "我们将为您的需求转达给酒店，但无法确保一定能满足",
    BREAKFASTNUM: "早餐 x {num}",
    NOBREAKFAST: "不含早",
    BREAKFAST99: "含早",
    BREAKFASTUNKNOWN: "未知",
    VALIDATEMES1: "未填写姓名",
    VALIDATEMES2: "未填写手机号",
    VALIDATEMES3: "未填写邮箱",
    VALIDATEMES4: "未填写支付方式",
    VALIDATEMES5: "未填写最晚到店时间",
    PHONEVA: "未填写正确的手机号",
    OUTOFPOLICY:
      "酒店价格/星级超标，由于贵司政策要求，无法进行预订，请从重新选择符合差标的酒店和价格！",
    OUTOFPOLICY2: "库存不足，不能预订！",
    PAYMENTTYPE1: "前台现付",
    PAYMENTTYPE2: "在线付",
    PAYMENTTYPE3: "公付",
    BURTIPS:
      "该订单为延时确认酒店，需等待服务组正常工作时间内确认。如需紧急协助，请致电服务小组。",
    BURTIPS2:
      "若预订后系统没有即时确认“预订成功“状态，需等待服务组在日常服务时段内与酒店确认。夜间服务时段（周一-周日 18:00-08:30）的预订，如您是当日入住，请电话联系服务小组。敬请留意。",
    BURTIPS3:
      "如需紧急协助，请致电服务小组 {customPhone}，非工作时间联系4008877076",
    SELECTTRIPS:
      "入住人不是白名单人员，根据企业规定需要选择出差审批单进行预订酒店",
    GUESTNAMERULE: "请您输入英文或拼音,如上样式:ZHANG/SAN",
    GUESTNAMERULESABRE: "请您输入英文或拼音,如上样式:ZHANG/SAN",
    EXCEEDEDPRICE: "您的价格预订上限为：{price}",
    EXCEEDEDPSTAR: "您的星级预订上限为：{star}星",
    TRIPSELECTGUEST: "该用户不是白名单，所选目的地与出差单目的地不符！",
    GUESTSELECTSABRE:
      "您选择的价格资源，仅支持输入英文名字或拼音，请重新维护临客信息！",
    INPUTCARDHOLDER: "样式: ZHANG/SAN",
    GUARANTEEDES2: "此预订将通过公司账户进行担保，如您在入住当天未按时办理入住手续，违约金将根据贵公司差旅政策执行。",
    VERIFYREPEATORDERTITLE: "您已有预订与现有预订日期重叠，请确认是否继续生成订单。",
    BURBOOKINGTITLE: "*本次预订需要二次确认，一般60分钟之内告知您最终订单状态。",
    ELONGGUARANTEE: "*当前订单30分钟后自动取消，请在30分钟之内完成支付。",
    ELONGHINT_LINE2: "*为了保证您的预订，可能需要您开通第三方支付，用于支付预订担保金，到店后需另付房费。担保金将于离店后5个工作日内退还。",
    MEMBERSHIPCARD: "会员卡",
    ADDMEMBERSHIPCARD: "添加会员卡",
    EDITMEMBERSHIPCARD: "修改会员卡",
    CHOSEMEMBERSHIPCARD: "请选择会员卡号",
    MEMBERSHIPCARDMSG: "* 您可以填写会员卡信息，以便在政策符合时为您累计积分，具体积分规则以酒店实际情况为准。",
    MEMBERSHIPCARDTRIPS: "请输入会员卡号",
    MEMBERSHIPCARDTRIPSRule: "!卡号为不能超过21位的数字字母组合",
    HOTELGROUP:"酒店集团",
    ReasonCode:"原因",
    CostCenterTitle1:"成本中心为必填，请选择成本中心继续预订！",
    CostCenterTitle2:"成本中心为必填项，请联系相关部门补充完整后再继续下单！",
    CostCenterUATPTitle1:"UATP/CTA卡缺失，请联系相关部门补充完整后下单！",
    CostCenterUATPTitle2:"您的UATP卡已过期，请联系相关部门调整完整后下单！",
    CostCenter:"成本中心",
    CostCenterEdit:"修改成本中心",
    CopyButton:"再次预订",
    CopyValidateMsg:"预订人帐户或权限发生变更，无法【再次预订】请从酒店搜索页预订。",
    DISCLAIMER:"请确保您提供担保的信用卡信息正确，否则酒店会对“预订成功“的订单做最终取消。最终解释权归酒店所有。",
    INTLTAXDISPLAY:"此价格可能不包含城市税等税费，需要到酒店额外支付。",
    BREAKFASTTITLE:"早餐信息可能有误",
    Reminder:"注意：",
    RoomTypePoints:"此房价可积分",
    RoomTypeNoPoints:"此房价不可积分",
    RoomTypeConfirmPoints:"此房价可否积分以入住时酒店确认为准",
    productCode:"价格代码：{productCode}",
    BreakFastAnalysis:"早餐解析:",
    BreakFastIncludingBreakfast:"含早餐",
    BreakFastBreakfastExcluded:"不含早",
    BreakFastAnalysisFailMessage:"早餐解析说明\n我们将价格计划完整英文说明推送到机器学习数据库，根据关键字推算此价格是否含早。准确率超过95%，但实际是否含早仍需酒店入住时确认。"

  },
  CONFIRMATION: {
    BREADCRUMB: "预订确认页（订单详情页）",
    BOOKING: "预订确认页",
    CONFIRMED: "已确认",
    ORDERNUM: "订单编号：",
    NEEDTOKNOW: "须知",
    NEED1: "该酒店不支持外宾。",
    NEEDNO: "该房间不可取消，不可改期。",
    NEEDYES: "该房间可免费取消。",
    NEED2: "在{date}时间前可免费取消。",
    NEED3ALL: "{date}时间后取消需收取全额担保费用。",
    NEED3: "{date}时间后取消需收取首晚担保费用。",
    NEED5: "{date}时间后取消需收取预付定金。",
    NEED6: "此单为虚拟卡担保订单，酒店可能需要您提供真实信用卡或其他通道担保，以确保预留房间。",
    TITLE2: "入住信息",
    TITLE3: "特殊要求",
    TITLE4: "注意事项",
    TITLE5: "预订人信息",
    TITLE6: "服务小组信息",
    CHECKINDATE: "入住日期",
    CHECKOUTDATE: "离店日期",
    ARRIVALTIME: "最晚到店时间",
    ROOMNUM: "房间数",
    TRAVLERNAME: "入住人姓名",
    MOBILE: "手机号",
    EMAIL: "邮箱",
    NIGHT: "间夜",
    MEMBERSHIP: "性别",
    EMPLOYEEID: "员工号",
    COSTCENTER: "成本中心",
    NOTEMATTERS1: "房价总计是否包含税费/服务费，请参考价格计划描述。",
    NOTEMATTERS2:
      "若您选择信用卡担保的所属银行为招商银行,后续将会收到预授权确认的短信,收到后,请尽快处理。",
    NOTEMATTERS3:
      "信用卡担保有可能会被刷取预授权；使用外币卡被刷预授权将会产生手续费及汇率差。",
    GUESTNUM: "入住人数：",
    BEDTYPE: "床型：",
    BREAKFAST: "早餐：",
    ROOMSIZE: "房间大小：",
    ORDERINFO: "订单信息",
    BOOKINGDATE: "预订时间：",
    HOTELTYPE: "酒店类型：",
    ORDERSTATUS: "订单状态：",
    GUARANTEEINFO: "担保信息",
    PAYMENTTYPE: "支付方式：",
    CARDNUM: "银行卡号：",
    AVGPRICE: "平均价格：",
    TOTALPRICE: "应付总额：",
    TOTALROOMPRICE:"应付房费：",
    BTNCANCEL: "取消订单",
    BTNUPDATE: "修改订单",
    CONFIRMBTNUPDATE: "确认修改",
    CANCELBTNUPDATE: "取消修改",
    BTNCONFIRM: "确认订单",
    BTNREJECT: "拒绝订单",
    BOOKINGNAME: "姓名",
    MOBILEPHONE: "手机号",
    BOOKINFOEMAIL: "邮箱",
    TCNAME: "姓名",
    TCTEL: "手机号",
    TCEMAIL: "邮箱",
    TCFAX: "传真",
    PRICETYPE: "价格类型：",
    TRAVELPOLICY: "出行政策：",
    PRICELINK: "点击查看价格明细",
    REMARKLINK: "点击查看备注信息",
    CONFIRMMSG: "是否确认取消订单？",
    CONFIRMREJECT: "是否拒绝该订单？",
    REFRESHCONTENT: "对不起，该房型已售完，请重新选择。",
    REFRESHBTN: "刷新",
    CANCLEBTN: "取消预订",
    PROCEED: "继续预订",

    BEDTYPE1: "房型：",
    ROOMINFO: "房型信息",
    BEDNUM: "大床",
    NEGOTIATEDHOTEL: "协议酒店",
    NEGOTIATEDHOTELTRUECP: "公司协议酒店",
    NEGOTIATEDHOTELTRUEAP: "CWT协议酒店",
    NEGOTIATEDHOTELFALSE: "非协议酒店",
    NEGOTIATEDPRICE: "协议价格",
    NEGOTIATEDPRICE0: "协议价",
    NEGOTIATEDPRICE1: "非协议价",
    INPOLICY: "符合",
    INPOLICYFALSE: "不符合",
    INPOLICYTRUE: "符合",
    SERVICETEAM: "服务小组",
    NONSMOKING: "无烟房",
    MIINFO: "自定义",
    ISMANUALORDER: "是否补录订单：",
    MANUALORDER: "是",
    NOTMANUALORDER: "否",
    UPDATEORDERDIALOG: "订单修改",
    ORDERSTATUSNAME: "订单状态",
    ORDERSTATUSRULES: "请选择订单状态",
    VALIDATESTATUSTIPS: "与当前订单状态一致，请重新选择",
    ORDERCANCLESUCCESS: "订单取消成功！",
    ORDERCANCLEFAILED: "订单取消失败！",
    BURCANCLETIPS:
      "该订单为延时确认酒店，需等待服务组正常工作时间内取消。如需紧急协助，请致电服务小组。",
    BURHOTELCONFIRMNO: "酒店确认号",
    BURCANCLEREMARK: "备注",
    ORDERUPDATESUCCESS: "订单修改成功！",
    ORDERCONFIRMSUCCESS: "确认订单成功！",
    ORDERREJECTSUCCESS: "拒绝订单成功！",
    GUARANTEETYPE: "是否担保:",
    GUARANTEETYPE1: "全部担保",
    GUARANTEETYPE2: "首晚担保",
    GUARANTEETYPE3: "无需担保",
    GUARANTEETYPE4: "已担保",
    GUARANTEETYPE5: "预付订金",
    CRMCONFIRMATIONNO: "酒店确认单号:",
    CRMSOURCE: "渠道:",
    CRMPNR: "PNR:",
    EMERGENCY: "紧急服务费:",
    ADVANCEPAYMENT: "垫资费:",
    CARDSWIPEFEE: "刷卡手续费:",
    BACK: "返回",
    BTNCONFIRMPAY: "担保支付",
    SYNC:"同步",
    Edit:"修改",
    PAYMENTSTATUSPRETIPS:"请于15分钟内完成支付，超时订单预订失败。",
    BEDTYPECN:"房型_中文",
    BEDTYPEEN:"房型_英文",
    ORDERMODIFYFAILED:"订单修改失败！",
    CCTITLE:"请输入抄送人邮箱，多个用“,”隔开",
    PREPAYREMARK:"如对金额有异议，请在离店后3天内联系服务小组提交退款申请，否则系统将默认结算完成",
    PAYBUTTON:"去支付",
    SubmitApproval:"提交审批",
    BeijingTime:"[北京时间]",
    LocalTime:"[当地时间]",
    VirtualGuarantee:"虚拟卡担保",
  },
  MAPRESULT: {
    MAPPAGE: "地图搜索结果页",
    RRICE: "价格",
    STARRATING: "星级",
    DISTANCE: "距离",
    SHOWONLIST: "列表显示",
    TEL: "电话：",
    ADDRESS: "地址：",
  },
  DESTINATION: {
    INHOTCITY: "国内热门城市",
    OUTHOTCITY: "海外热门城市",
    HOTCITY: "热门城市",
    NOTDEST: "未查询到目的地信息",
    SEARCHPL: "请输入搜索关键词",
    CLOSEPOP: "关闭",
    WAITSEARCHTIP: "请稍等，正在检索...",
    SEARCHRECORDS: "最近搜索记录",
    CLEARHISTORY: "清除历史",
  },
  GUARANTEE: {
    //TEMP
    ROOMTYPE1: "豪华大床房",
    ROOMDESCRIPTION: "该房型楼层位于{floor}层",
    BANK1: "中国银行",
    BANK2: "农业银行",
    BANK3: "工商银行",
    BANK4: "建设银行",
    INPUTCARDHOLDER: "英文字母，如：Li Meimei",
    ADDNEWCARD: "使用新卡",
    CONFIRMBOOKING: "确认预订",
    SUPPORTCREDITCARD: "支持的信用卡:",
    ROOMTYPE: "房型:",
    REMINDER: "请确认下方预订信息:",
    CHECKINDATE: "入住日期:",
    CHECKOUTDATE: "离店日期:",
    ROOMNUMBER_PREFIX: "共：",
    ROOMNUMBER_SUFFIX: "晚",
    TOTALAMOUNT: "总价：",
    NIGHTS_PREFIX: "房间数：",
    NIGHTS_SUFFIX: "间",
    SELECTHOTEL: "选择酒店",
    CONFIRMATION: "确认页",
    GUARANTEE: "支付担保页",
    NAMEOFCARDHOLDER: "持卡人姓名:",
    IDTYPE: "证件类型:",
    CREDITCARDTYPE: "信用卡类型：",
    PERIODOFVALIDITY: "有效期:",
    MOBILEPHONE: "注册手机号:",
    IDNUMBER: "证件号:",
    CARDNUMBER: "信用卡号:",
    ISSUEBANK: "发卡银行",
    SAVECARDINFOMATION: "是否保存信用卡信息",
    BREAKFAST: "早餐 x {num}",
    BREAKFAST1: "早餐:",
    RULECREDITTYPE: "请选择信用卡类型",
    RULECREDITVIL: "请输入正确的信用卡号",
    RULECREDITCARD: "未填写信用卡号",
    RULECARDNAME: "未填写持卡人姓名",
    RULEVALIDITYDATE: "未填写有效期",
    RULEVALIDITYDATE2: "请输入正确的有效期",
    RULEVALIDITYDATE3: "已过期",
    RULEIDTYPE: "请输入正确的证件号",
    NAME: "入住人姓名：",
    TEL: "入住人电话：",
    EMAIL: "入住人邮箱：",
    CARDNAMEVALIDATE: "姓名错误，仅支持英文和一个空格（隔开姓和名）如：“张三强” 为 “Zhang Sanqiang”",
    CARDNAMEVALIDATECHINA: "信用卡姓名错误，仅允许输入中文",
    CARDTYPETIPS: "不支持此类信用卡，请更换您的信用卡",
    CARDNOMSG: "无符合条件的信用卡",
    CARDNULLMSG: "未获取到信用卡",
    ISFIRST: "是否默认",
    CARDPROPERTY: "卡性质",
    CARDPROPERTYCOM: "公司",
    CARDPROPERTYPER: "个人",
    RULECARDTYPE: "未选择证件类型",
    RULECARDNUM: "未填写证件号",
    RULECHINESENAME: "请输入中文名称",
    RULECHINESECVV: "请输入CVV验证码",
    RULECODE: "请输入验证码",
    SMSCODE: "发送验证码",
    SMSCODEREST: "s后重新发送",
    CancelPay: "取消支付",
  },
  GUESTSCOMPONENTS: {
    ROOM: "间",
    ADULT: "人",
    ROOMNUM: "房间",
    ADULTNUM: "成人",
  },
  USERDIALOG: {
    TABNAEM1: "员工列表",
    TABNAEM2: "临客列表",
    BTNGUEST: "添加临客",
    GUEST: "临客",
    TABLENAME: "姓名",
    TABLETEL: "电话",
    NAME: "姓名：",
    TEL: "电话：",
    SEARCHTEL: "电话",
    SEARCHNAME: "姓名",
    TABLEEMPLOYEEID: "员工编号",
    DEPARTMENT: "部门",
    OPERATION: "操作",
    SELECT: "选择",
    IDNUMBER: "证件号",
    BTNSEARCH: "搜索",
    EMAIL: "邮箱：",
    SEARCHEMAIL: "邮箱",
    GUESTNAME: "请输入名称",
    GUESTMOBILE: "请输入联系方式",
    GUESTEMAIL: "请输入邮箱",
    GUESTEMAIL2: "请输入正确的邮箱地址",
    TRAVELERTITLE: "行程单出行人",
  },
  PRICEDIALOG: {
    TITLE: "价格明细",
    DATE: "时间",
    PRICE: "价格(含税)",
    TAXSTATE: "税务：税费需加收",
    TAX: "税费",
    FEE: "其他",
  },
  MANUAL: {
    TAX: "税费:",
    OTHERS: "其他:",
    ADVANCEPAYMENT: "垫资费:({Type})",
    ORDERMANAGE: "订单管理",
    MANUALORDER: "订单补录",
    SELECTGUEST: "入住人信息",
    CLIENTLIST: "客户列表",
    CLIENT: "客户名称：",
    SEARCHCLIENTNO: "客户编号",
    SEARCHCLIENT: "客户名称",
    CONTACTNAME: "联系人姓名",
    PROCESSORS: "处理人",
    CONTACTMOBILE: "联系人手机号:",
    CONTACTEMAIL: "联系人邮箱:",
    GUESTNAME: "入住人姓名",
    OTHERGUESTNAME:"其他入住人：",
    ADDOTHERGUESTNAME:"添加其他入住人",
    MOBILE: "手机号：",
    EMAIL: "邮箱：",
    APPROVEDTRIPS: "出差单号：",
    ORDERINFO: "订单信息",
    HOTELNO: "酒店确认号：",
    SUPPILENO: "供应商单号：",
    CITY: "入住城市：",
    ORDERSTATUS: "订单状态",
    CHECKIN: "入住日期：",
    CHECKOUT: "离店日期：",
    PAYMENTSTATUS: "支付状态：",
    SETTLEMENT: "支付方式：",
    PRICETYPE: "价格类型：",
    RATEACCESSCODE: "协议价代码：",
    SERVICEFREE: "服务费：",
    URGENTFEE: "紧急服务费",
    REMARK: "备注：",
    HOTELINFO: "酒店信息",
    HOTELIST: "酒店列表",
    HOTELNAME: "酒店名称：",
    SEACHHOTELNAME: "酒店名称",
    HOTELNAMECN: "酒店名称中文",
    HOTELNAMEEN: "酒店名称英文",
    FXID: "FX ID",
    STARRATING: "星级：",
    SEACHSTARRATING: "星级",
    TELFAX: "电话/传真：",
    CONTACTTEL: "联系电话",
    HOTELADDRESS: "地址",
    ADDRESS: "地址：",
    HOTELTYPE: "酒店类型：",
    BREAKFAST: "早餐：",
    ROOMTYPE: "房型：",
    SMORKING: "吸烟情况：",
    CHANNEL: "渠道：",
    CHANNELDIALOGTITLE: "渠道",
    MONERARTUNIT: "货币单位：",
    TOTAL: "房价总计(含税)：",
    PRICEDETAILS: "价格明细：",
    PRICEDETAILSDATE: "日期：",
    PRICEDETAILSPRICE: "价格(含税)：",
    FILLINTHEDETAILEDDAILYPRICE: "填写详细间夜价格",
    MANAGEMENTINFORMATION: "MI 信息",
    POLICYINFO: "政策信息",
    GUARANTEE1: "担保政策：",
    CANCELLATION: "取消政策：",
    TOTALTAXES: "总税费：",
    TOTALFEES: "费用合计：",
    LATESTARRIVALTIME: "最晚到店时间：",
    BTNSUBMIT: "提交",
    SUBMITBACKEND: "提交后台",
    VALIDATEAPPROVEDTRIPANDCITY:
      "您选择的入住城市与出差单城市不符合，请确认关联出差单是否正确？",
    VALIDATECANCELDATETIPS: "限时取消所选日期不符合限时退订规则",
    ORDERCREATEDSUCCESSFULLYTIPS: "创建订单成功，订单编号为",
    ORDERCREATEDFAILEDTIPS: "创建订单失败,",
    ORDERCREATEDEXCEPTIONTIPS: "创建订单异常,",
    SELECTPLACEHOLDER: "请选择",
    SELECTPDEADLINEDATE: "请选择限时取消日期",
    SELECTPDEADLINETIME: "请选择限时取消时间",
    APPROVEDTRIPSLIST: "出差单列表",
    MANUALORDERLIST: "待补单列表",
    SYSTEMAPPROVEDTRIPSNO: "系统出差单号",
    CUSTOMERAPPROVEDTRIPSNO: "客户出差单号",
    APPROVEDTRIPSERPERSONNEL: "出差人",
    APPROVEDTRIPSLOCATION: "出差地点",
    APPROVEDTRIPSREASON: "出差事由",
    APPROVEDTRIPSDate: "出差时间",
    VALIDATECUSTOMERNAME: "请输入客户名称",
    VALIDATECONTACTNAME: "请输入联系人姓名",
    VALIDATECONTACTMOBILE: "请输入联系人手机号",
    VALIDATECONTACTEMAIL: "请输入联系人邮箱",
    VALIDATETRAVELERNAME: "请输入入住人姓名",
    VALIDATEMOBILE: "请输入手机号",
    VALIDATEPHONEFORMAT: "请输入正确的手机号",
    VALIDATEEMAIL: "请输入邮箱",
    VALIDATECITYNAME: "请输入入住城市",
    VALIDATEORDERSTATUS: "请输入订单状态",
    VALIDATECHECKINDATE: "请输入入住日期",
    VALIDATECHECKOUTDATE: "请输入离店日期",
    VALIDATECHECKOUTDATEANDINDATE: "请确认离店时间要晚于入住时间",
    VALIDATEPAYMENTSTATUS: "请输入支付状态",
    VALIDATESETTLEMENTMETHOD: "请输入结算方式",
    VALIDATEPRICETYPE: "请输入价格类型",
    VALIDATEHOTELNAME: "请输入酒店名称",
    VALIDATEROOMTYPENAME: "请输入房型",
    VALIDATEBREAKFAST: "请输入早餐",
    VALIDATEHOTELTYPE: "请输入酒店类型",
    VALIDATESERVICEFEE: "请输入服务费",
    VALIDATEURGENTFEE: "请输入紧急服务费",
    VALIDATECHANNEL: "请输入渠道",
    VALIDATECHANNELOTHER: "请输入其他渠道",
    VALIDATECURRENCYCODE: "请输入货币单位",
    // VALIDATETOTALPRICE: "请输入房价总计",
    VALIDATETOTALPRICE: "请将右侧详细间夜价格输入完整",
    VALIDATEDAILYPRICES: "请输入详细间夜价格",
    VALIDATEGUARANTEETYPE: "请输入担保政策",
    VALIDATECANCELLATIONPOLICY: "请输入取消政策",
    VALIDATECANCELDATEONPOLICY: "请输入限时取消日期和时间",
    VALIDATEADVANCEPAYMENT: "请输入垫资费",
    VALIDATEHOTELNO: "请输入酒店确认号",
    VALIDATELATESTARRIVALTIME: "请输入最晚到店时间",
    VALIDATEHOTELNOCN: "*请不要输入中文",
    VALIDATEPAYMENTSTATUSPUBLIC: "该企业未开启{mode}公付支付方式，请选择其他支付方式",
    VALIDATEOTHERGUESTPAYMENT: "公付不支持双人入住，请删除第二入住人信息再提交！",
  },
  ORDERINFO: {
    LinkName: "订单管理",
    PageTite: "订单列表页",
    MyOrderTitle: "我的订单",
    DepartmentOrderTitle: "部门订单",
    HotelOrderTitle: "酒店订单",
    ManualOrderTitle: "订单补录",
  },
  MYORDER: {
    Client: "客户名称",
    Department: "部门名称",
    Traveler: "入住人",
    OtherTraveler: "第二人",
    Destination: "目的城市",
    HotelName: "酒店名称",
    DateType: "日期类型",
    BookingDate: "预订时间",
    CheckInDate: "入住时间",
    StartDate: "开始日期",
    EndDate: "结束日期",
    OrderNo: "订单号",
    OrderStatus: "订单状态",
    PaymentType: "支付类型",
    Search: "搜索",
    GuaranteePolicy: "担保政策",
    RESPONSEDATA: {
      city: "zh-CN",
    },
  },
  ORDERLIST: {
    RESPONSEDATA: {
      hotelName: "zh-CN",
    },
    WARNING: "请选择日期类型",
    Client: "客户名称",
    OrderNo: "订单号",
    Traveler: "入住人",
    City: "城市",
    HotelName: "酒店名称",
    BookingDate: "预订时间",
    CheckInDate: "入住时间",
    CheckOutDate: "离店时间",
    ActualCheckInDate: "实际入住时间",
    ActualCheckOutDate: "实际离店时间",
    PaymentType: "支付类型",
    PaymentAmount: "订单金额",
    OrderStatus: "订单状态",
    APPROVALSTATUS: "审批状态",
    ManualOrder: "补录订单",
    IsManualOrder: "是",
    IsnotManualOrder: "否",
    Operation: "操作",
    Detail: "详情",
    DELETE: "删除",
    OPERATIONLOG: "操作日志",
    NoData: "对不起，没有符合搜索条件的订单，请检查搜索条件。",
    CONFIRMCHECK: "请填写开始日期和结束日期后再进行搜索",
    TIMECHECK: "请选择不早于开始日期的结束日期",
    //temp will delete
    TABLEVAL1: "订单H_21090878",
    TABLEVAL2: "刘忠",
    TABLEVAL3: "上海",
    TABLEVAL4: "吉米小住",
    TABLEVAL6: "到店付",
    TABLEVAL8: "已确认",
    EAPORTEXCEL: "导出Excel",
  },
  OPTIONS: {
    BOOKINGSUCCESS: "预订成功",
    CancelBOOKINGSUCCESS: "取消成功",
    PAYMENTSTATUSAll: "全部",
    PAYMENTSTATUSHotel: "到店付",
    PAYMENTSTATUSPublic: "公付",
    PAYMENTSTATUSpre: "在线付",
    OrderSUCCESS: "预订成功",
    OrderCancel: "已取消",
    OrderLeave: "已离店",
    OrderPaymentStatus: "未到店",
    OrderPendingStatus: "待确认",
    PENDINGBOOKING: "待预订",
    PENDINPROCESSED: "待处理",
    PENDINGCANCEL: "待取消",
  },
  COMMONPARAM: {
    // 后台中英文固定格式
    RESPONSEDATA: {
      SHOWTYPE: "zh-CN",
    },
    WINDOW: {
      WINDOW0: "无窗",
      WINDOW1: "有窗",
      WINDOW2: "部分有窗",
      WINDOW3: "内窗",
      WINDOW4: "天窗",
      WINDOW5: "封闭窗",
      WINDOW6: "飘窗",
    },
    WIFI: {
      WIFI0: "没有网络",
      WIFI1: "全部房间有WIFI且免费",
      WIFI2: "部分房间有WIFI且免费",
      WIFI3: "全部房间有WIFI且收费",
      WIFI4: "部分房间有WIFI且收费",
    },
    PAYMENTTYPE: {
      PAYMENTTYPE1: "前台现付",
      PAYMENTTYPE4: "全部",
      PAYMENTTYPE2: "在线付",
      PAYMENTTYPE3: "公付",
      PAYMENTTYPENAN: "支付方式",
    },
    ORDERSTATE: {
      BOOKED: "预订成功",
      PENDING_BOOKING: "待预订",
      PENDING_CONFIRMATION: "待确认",
      CANCELLED: "已取消",
      REFUNDED: "已退款",
      CHECKOUT: "已离店",
      NOSHOW: "未到店",
      CWT_PENDING_CANCELLATION: "待取消",
      CWT_PENDING_CONFIRMATION: "待处理",
      BOOKING_FAILED: "预订失败",
      CWT_PENDING_APPROVAL: "待审批",
      CWT_PENDING_SUBMISSION: "待提交",
      CWT_DELETE: "已删除",
    },
    APPROVALSTATUS: {
      0: "待提交",
      1: "待审批",
      2: "审批通过",
      3: "审批拒绝",
      4: "已超时"
    },
    //防疫工具集地址
    NAV1URL: "https://obt.mycwt.com.cn/index-travel.aspx",
  },
  BIGORDER: {
    AddBigOrder: "添加到大订单",
    CreateBigOrder: "生成大订单",
    Client: "客户名称",
    BigOrderNo: "大订单号",
    UserName: "员工名字",
    TotalPrice: "总金额",
    CreateByName: "创建人",
    CreateTime: "创建时间",
    OPERATION: "选择",
  },
  OPERATIONLOG: {
    OrderOperationDetails: "订单操作详情",
    CreateTime: "创建时间",
    Operation: "操作",
    Description: "摘要",
    CreateById: "创建人",
    Type: "类别",
  },
  HOTELORDEREMAIL: {
    APPROVEDINFO: "行程单信息",
    SUBSCRIBEREMAIL: "预订人邮箱：",
    CHECKINEMAIL: "入住人邮箱：",
    CHECKINEMAILTITLE: "入住人邮箱",
    CCEMAIL: "抄送邮箱：",
    REPEAT: "发送",
    REPEATMSG: "重新推送成功!",
    ENNAME:"英文",
    CNNAME:"中文",
  },
  REMARKINFO: {
    REMARKLOG: "备注日志",
    DATE: "日期",
    OPERATOR: "操作人",
    DETAIL: "详情",
    ADDREMARK: "添加备注",
    ADDREMARKMSG:"请输入备注信息",
    ADDERRORMSG:"添加备注信息失败!"
  },
  SERVICECHARGEINFO: {
    TIPS: "确定修改",
    HINT: "提示",
    SERVICECHARGESUCCESS: "修改成功",
    SERVICECHARGEERROR:"修改失败",
    QTYS:"0:不含早,99:含早,不指定具体份数,1-99:指定早餐具体份数."
  },
  EGuarantee: {
    CardTypes: "此预订仅支持【银联】卡担保/支付！",
    DetailTIPMSG:"锁定房源需支付定金，到店房费另付，离店后五个工作日内返还定金",
    SabreDetailTIPMSG:"您随时将被收取订单全额的预付款。",
    SabreDetailTIPMSGDeposit:"预付定金",
    AgreeAgreement:"我同意以上操作",
    GetGuestAuthorization:"获取客人授权",
  },
  BANNERINFO:{
    ACTIVITENAME: "活动名称",
    ACTIVITECODE: "活动编码",
    PAGETYPE: "页面类型",
    STARTDATE: "生效日期",
    ENDDATE: "结束日期",
    ACTIVITESTATUS: "活动状态",
    CREATEDBY: "创建者",
    CREATEDDATE: "创建日期",
    REMARK: "备注",
    SEARCH:"搜索",
    ADDBANNERMAINTAIN:"新增",
    NoData: "对不起，没有符合搜索条件的活动，请检查搜索条件。",
    AddBANNER:"添加活动",
    PCPICTUREURLCN: "PC中文图片地址",
    PCPICTUREURLEN: "PC英文图片地址",
    PCFILEURLCN: "PC中文附件地址",
    PCFILEURLEN: "PC英文附件地址",
    H5PICTUREURLCN: "H5中文图片地址",
    H5PICTUREURLEN: "H5英文图片地址",
    H5FILEURLCN: "H5中文附件地址",
    H5FILEURLEN: "H5英文附件地址",
    UPLOADPRICEMSG: "* 仅支持PNG,JPG格式。像素大小为{PriceWidth}*100",
    UPLOADFILEMSG: "* 仅支持PDF格式。上传文件最大5MB",
    VALIDATEACTIVITENAME: "请输入活动名称",
    VALIDATEACTIVITENAMELENGTH: "活动名称最多输入50字符",
    VALIDATEPAGETYPE: "请选择页面类型",
    VALIDATELENGTH: "最多输入{max}字符",
    UPDATEADSSUCCESS:"保存成功",
    UPDATEADSFAIL:"保存失败，请稍候再试",
    UPLOADFILEMSGBTN:"上传图片和PDF文件"
  },
  RESENTSMSINFO:{
    RESENTSMS: "重发短信",
    SMSINFO:"短信信息",
    SEND:"发送",
    BOOKINGAGENTMOBILE:"预订人手机号：",
    GUESTMOBILE:"入住人手机号：",
    RESENTSUCCSEE:"发送成功",
    RESENTFAIL:"发送失败，请稍候再试",
    VALIDATEMOBILE:"请输入手机号",
    DOWNLOADPDF:"下载邮件申请单",
  },
  MANUALORDERHOTEL:{
    SEARCHBUTTON: "跨城市搜酒店",
    CITYNAME: "城市",
    PROVINCENAME: "州/省",
    COUNTRYNAME: "国家",
  },
  OTHERPRODUCT:{
    MSG: "您是否还要预订其他产品？",
  },
  CREDITCARD:{
	  BANKCODENAME: "选择信用卡",
    CREDITCARDTYPE: "信用卡类型",
    CREDITCARDNAME: "持卡人姓名",
    CREDITCARDNO: "卡号",
    CARDTYPE: "卡证件类型",
    CARDID: "证件号",
    CREDITCARDDATE: "有效期",
    MOBILEPHONE: "注册手机号",
    CVV: "CVV",
    BANKNAME: "发卡银行",
    SIGNING:"已签约",
    UNSIGNING:"未签约",
    CAPTCHA:"验证码",
    GETCAPTCHA:"获取验证码",
    SAVECARDINFOMATION:"是否保存卡片",
    PAYBUTTON:"支付",
    COUNTDOWN:"秒)",
    VALIDATECREDITCARDNAME: "请输入持卡人姓名",
    VALIDATECREDITCARDNO: "请输入卡号",
    VALIDATECARDID: "请输入证件号",
    VALIDATECREDITCARDDATE: "请输入月年,如0522",
    VALIDATEMOBILEPHONE: "请输入注册手机号",
    VALIDATEMSG:"请输入{Msg}",
  },
  PAYORDERPAGE:{
    Amount:"支付金额：",
    QRCodeMsg_Ali:"请打开支付宝扫描二维码支付",
    QRCodeMsg_Wechat:"请打开微信扫描二维码支付",
    AddNewCard:"添加新卡支付",
    PaymentSolutions:"支持的支付方式",
    AddCreditCard:"新增信用卡",
    EditCreditCard:"修改信用卡",
    CardAuthorization:"信用卡签约",
    AgreePay:"同意协议并支付",
    PaymentSucceeded:"支付成功",
    PaymentFailed:"支付失败",
    DeleteCreditCardFailed:"删除失败",
    PaymentAlert:"请确认是否已完成支付?",
    PaymentAlertYes:"已完成支付",
    PaymentAlertNo:"未完成支付",
    CTACheckMsg:"成本中心错误,请联系CWT服务团队.",
  },
  REFUNDREQUESTINFO:{
    REFUNDBUTTON: "开具发票",
    REFUNDTITLE:"请确认订单信息",
    CHECKINDATE:"入住日期:",
    CHECKOUTDATE:"离店日期:",
    ROOMCHARGE:"房费:",
    FREE:"服务费:",
    REFUNDMSG:"确认后方可开具发票，同时不支持提交退款申请。",
    CONFIRMED:"确认",
    REFUNDREQUESTTITLE:"退款申请信息",
    ACTUALCHECKINDATE: "实际入住时间:",
    ACTUALCHECKOUTDATE: "实际离店时间:",
    REFUNDREQUESTAMOUNT:"申请退款金额:",
    REMARK:"说明:",
    SUBMIT:"提交",
    REFUNDREQUESTMSG:"申请退款后需约5天的反馈处理时间，不含服务费和刷卡手续费",
    SHOWDATEPICKER:"是否是未入住:",
    VALIDATEAMOUNT:"请输入退款金额",
    VALIDATEMAXAMOUNT:"退款金额不能大于订单总金额",
  },
  INVOICINGSTATUS:{
    INVOICINGSTATUS0: "开具发票",
    INVOICINGSTATUS1: "开票中",
    INVOICINGSTATUS2: "查看发票",
  },
  REFUNDREQUESTBUTTONMSG:{
    REFUNDREQUEST0: "退款申请",
    REFUNDREQUEST1: "已提交",
    REFUNDREQUEST2: "审核中",
    REFUNDREQUEST3: "审批通过",
    REFUNDREQUEST4: "已拒绝",
    REFUNDREQUEST5: "退款中",
    REFUNDREQUEST6: "退款完成",
  },
  INVOICINGINFO:{
    TOTALPRICE:"房费金额",
    INVOICINGPRICE:"可开票金额",
    INVOICINGDETAIL:"含：房费 {roomFees}，服务费 {serviceFees}",
    INVOICINGTYPE: "发票类型",
    INVOICINGSERVICEFEES: "服务费单开票",
    INVOICIGSTITLE:"开票主体",
    SERVICEFEESINVOICINGTYPE: "服务费发票类型",
    INVOICINGCOMPANY: "中航嘉信商务旅行管理有限公司",
    INVOICINGCOMPANY1: "中航嘉信商务旅行管理有限公司上海分公司",
    TIPS:"如金额不准确，请联系客服另行开具发票",
    TIPS1:"请确保以上发票信息与您的营业执照/税务登记信息相同",
    DELETEMSG:"确定要删除？",
    DEFAULT:"默认",
    SUBMITBUTTONTIP:"已收到开票申请，发票会在5个工作日内发送到您的邮箱。",
    SUBMITTITLE:"提示",
    PERSONALINVOICEHEADER:"个人发票抬头",
    CORPORATERETRIEVEDINVOICEHEADER:"公司发票抬头",
    INVOICINGDETAILINFO:{
      TITLE:"发票信息",
      INSTRUCTION:"开票说明",
      INSTRUCTIONMSG:"本电子邮件及其所附带的任何文件包含了保密信息，仅指向该地址之特定目标收件人。若您并非该邮件的目标收件人，或您为应向目标收件人转达该邮件的目标收件人之雇员或代理人，不得以任何形式传播、发布、复制或以其它任何方式使用该邮件及其附件（包括任何原始信息的备份）。若您错误地接收到该邮件，请回复该邮件告知我们这一错误，同时请将该邮件从您的电脑中删除。本邮件中出现的中航嘉信商务旅行管理有限公司的知识产权（若已如此注明）受知识产权法律的保护。任何侵犯本公司知识产权和保密信息的行为都将受到法律追究。",
      HEADERTYPE:"抬头类型",
      HEADER:"发票抬头",
      TAXREGISTERNUMBER:"税务登记号",
      BANKNAME:"开户行",
      BANKNUMBER:"银行账号",
      REGISTEREDADDRESS:"注册地址",
      REGISTEREDPHONE:"注册电话",
      DETAIL:"发票内容",
      DETAILMSG_LINE1: "经纪代理服务 代订房费 {totalPrice}",
      DETAILMSG_LINE2: "经纪代理服务 服务费 {serviceFees}",
      INPUTPLACEHOLDER:"请填写{MSG}",
      TAXREGISTERNUMBERPLACEHOLDER:"请填写统一社会信用代码/税务登记号",
      ValidateInputCharacters:"输入不能超过100个字符或50个汉字",
      ValidateInputTaxNumber:"税务号必须是7-20位的数字或字母",
      ValidateHeaderName:"购销方不能为同一家企业",
    },
    CONTACTSINFO:{
      CONTACTSMSG:"联系人信息",
      NAME:"联系人",
      PHONE:"联系人电话",
      EMAIL:"邮箱地址"
    }
  },
  H5INVOICINGINFO:{
    HEADERPLACEHOLDER:"请选择发票抬头",
    INVOICINGLISTTITLE:"选择报销凭证抬头",
    INVOICINGTYPETITLE:"发票类型",
    INVOICINGCONTACTSTITLE:"选择接收方式",
    INVOICINGTYPE_NORMALTIPS:"* 提交开票申请后4日内发至电子邮箱",
    CONTACTSTITLE:"选择联系人",
    TIPS:"最多可保存3条记录",
    //INVOICINGTYPE_APPRECIATETIPS:"提交开票申请后"
  },
  INVOICINGTYPE:{
    NORMAL: "增值税电子普通发票",
    APPRECIATE: "增值税电子专用发票",
  },
  INVOICINGHEADERTYPE:{
    CORPORATION:"企业普票",
    NOCORPORATION:"企业专票",
    PERSONS:"个人"
  },
  INVOICINGBUTTON:{
    CHOSEHEADER:"选择发票抬头",
    CHOSE:"选择",
    DEIT:"编辑",
    DELETE:"删除",
    ISFIRST:"设为默认",
    SAVE:"保存",
    OPENISFIRST:"开启",
    CLOSEISFIRST:"关闭",
    SUBMIT:"提交",
    CANCEL:"取消",
    CONFIRM:"确定",
    RESENT:"重发电子发票",
    ADDINVOICING:"新增发票抬头",
    CHOSECONTACTS:"选择联系人",
    ADDCONTACTS:"新增联系人"
  },
  INCIDENTREPORTINFO:{
    Client:"客户名称",
    Traveler:"入住人",
    Phone:"手机号",
    Booker:"预订人",
    CITY: "入住城市",
    ChooseDate: "时间选择",
    BookingDate: "预订时间",
    CheckInDate: "入住时间",
    HotelName: "酒店名称",
    OrderNo: "订单号",
    OrderStatus: "订单状态",
    PaymentType: "支付方式",
    VendorOrderNo: "供应商订单号", 
    Vendor: "供应商", 
    HotelType: "酒店类型",
    BurhotelConfirmNo:"酒店确认号",
    BookingSource:"预定来源",
    DomesticOrInternational:"国内国际",
    AdvancedSearch:"高级搜索",
  },
  PAYMENTTYPE:{
    PAYMENTTYPE:"付款方式",
    KQ:"快钱",
    Alipay:"支付宝",
    WeChatPay:"微信",
    CTA:"万事达-CTA",
  },
  HOTELGROUPINFO: {
    Hyatt:"凯悦",
    Radisson:"丽笙",
    Ramada:"华美达",
    Wyndham:"温德姆",
    Marriott:"万豪",
    Accor:"雅高",
    Raffles:"莱佛士",
    Kempinski:"凯宾斯基",
    TheRitzCarlton:"丽兹卡尔顿",
    Hilton:"希尔顿",
    ShangriLa:"香格里拉",
    IHG:"洲际",
    Millennium:"千禧",
    Rosewood:"瑰丽",
    Preferred:"璞富腾",
    Wanda:"万达",
    HUAZHU:"华住",
    JinJiangInternational:"锦江国际",
    JinjiangChina:"锦江",
    Dossen:"东呈",
    DossenInternational:"东呈国际",
    Homeinns:"首旅如家",
    Ascott:"雅诗阁",
    Atour:"亚朵",
    Banyantree:"悦榕",
    Fraser:"辉盛",
    Jumeirah:"卓美亚",
    Langham:"朗廷",
    MandarinOriental:"文华东方",
    MarcoPolo:"马哥孛罗",
    NewCentury:"开元",
    SSAW:"君亭",
  },
  route: {
    Home: "首页",
    Result: "酒店列表页",
    Detail: "酒店详情页",
    Booking: "预订页",
    Guarantee: "担保页",
    Confirmation: "确认页",
    MapResultMobile: "地图结果移动端",
    MapHotelListMobile: "地图酒店列表移动端",
    GaodeMap: "酒店列表地图页",
    OrderList: "订单列表页",
    EGuarantee: "担保页",
    PayOrder: "支付订单页",
    Invoicing: "发票管理页",
    IncidentReport: "事件报告页"
  },
  cardTypeDialog:{
    idNumber: "证件号码",
    title: "编辑证件信息",
    certificateType: '证件类型',
    certificateNumber: '证件号',
    lastName: '证件姓',
    firstName: '证件名',
    name: '姓名',
    birthDate: '出生日期',
    gender: '性别',
    expiryDate: '证件有效期',
    nationality: '国籍',
    issuingCountry: '签发国',
    male: '男',
    female: '女',
    save: '保存',
    cancel: '取消',
  },
  cardTypes: {
    IdCard: "身份证",
    Passport: "护照",
    HomeReturnPermit: "回乡证",
    TaiwanCard: "台胞证",
    OfficerCard: "军人证",
    HongKongAndMacaoPass: "港澳通行证",
    TaiWanPass: "台湾通行证",
    HkAndMacauPass: "港澳台居民居住证",
    ForeignPermanentResidentCard: "外国人永久居留证",
  },
  cardTypeRules: {
    IdCardEmpty:"证件号不能为空！",
    IdCardInvalid:"输入的身份证号位数错误！",
    IdCardFormat:"证件号码格式错误！",
    NameEmpty:"姓名不能为空！",
    NameInvalid:"身份证姓名必须为中文, 且不允许输入“身份证”字样！",
    CardNumberInvalid:"证件号错误！",
    SurnameEmpty:"证件姓不能为空！",
    GivenNameEmpty:"证件名不能为空！",
    CertificateNameInvalid:"证件姓名必须填中文！",
    CertificateEngNameInvalid:"证件姓名必须填英文！",
    birthDateInvalid:"出生日期错误！",
    expiryDateInvalid:"证件有效期错误!",
    genderInvalid:"性别不能为空!",
    notionalityInvalid:"国籍不能为空!",
    issuingCountryInvalid:"签发国家不能为空！",
  }
};
